<div fxLayout="row wrap">
    <div fxFlex="100">
      <mat-card>
        <mat-card-content>
          <div fxLayout="row wrap" class="align-items-center">
            <div fxFlex.gt-md="25" fxFlex.gt-lg="25" fxFlex="100">
              <mat-form-field>
                <input matInput (keyup)="applyFilter($event.target.value)" placeholder="Filter">
              </mat-form-field>
            </div>
            <div fxFlex.gt-md="75" class="text-right">
              <button mat-raised-button (click)="openDialog('Add',{})" color="primary">Add Employee</button>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
  </div>
  <div fxLayout="row wrap">
    <div fxFlex="100">
      <mat-card>
        <mat-card-content>
          <div class="table-responsive">
            <table mat-table [dataSource]="dataSource" class="table employee-list no-wrap">
  
              <ng-container matColumnDef="#">
                <th mat-header-cell *matHeaderCellDef> # </th>
                <td mat-cell *matCellDef="let element"> {{element.id}} </td>
              </ng-container>
  
              <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef> Name </th>
                <td mat-cell *matCellDef="let element">
                  <div class="d-flex">
                    <img class="mat-card-avatar" [src]='element.imagePath'>
                    <div class="m-l-15">
                      <p class="font-bold m-b-0 m-t-0">{{ element.Name }}</p>
                      <small>{{element.Position}}</small>
                    </div>
                  </div>
                </td>
              </ng-container>
  
              <ng-container matColumnDef="email">
                <th mat-header-cell *matHeaderCellDef> Email </th>
                <td mat-cell *matCellDef="let element"> {{element.Email}} </td>
              </ng-container>
  
              <ng-container matColumnDef="mobile">
                <th mat-header-cell *matHeaderCellDef> Mobile </th>
                <td mat-cell *matCellDef="let element"> {{element.Mobile}} </td>
              </ng-container>
  
              <ng-container matColumnDef="date of joining">
                <th mat-header-cell *matHeaderCellDef> Date of Joining </th>
                <td mat-cell *matCellDef="let element"> {{element.DateOfJoining | date :'fullDate'}} </td>
              </ng-container>
  
              <ng-container matColumnDef="salary">
                <th mat-header-cell *matHeaderCellDef> Salary </th>
                <td mat-cell *matCellDef="let element"> {{element.Salary}} </td>
              </ng-container>
  
              <ng-container matColumnDef="projects">
                <th mat-header-cell *matHeaderCellDef> Projects </th>
                <td mat-cell *matCellDef="let element"> {{element.Projects}} </td>
              </ng-container>
  
              <ng-container matColumnDef="action">
                <th mat-header-cell *matHeaderCellDef> Action </th>
                <td mat-cell *matCellDef="let element" class="action-link">
                  <a (click)="openDialog('Update',element)" class="m-r-10 cursor-pointer"><i class="fa fa-pencil"></i></a>
                  <a (click)="openDialog('Delete',element)" class="m-r-10 cursor-pointer">
                    <i class="fa fa-trash text-danger"></i>
                  </a>
                </td>
              </ng-container>
  
              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
            <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
  </div>
  